import { AiGeneratedQueryData } from 'src/app/shared/services/ai-search/ai-search.service';
import {
  CompanyQueryRequest,
  Lexicon,
} from 'src/app/shared/models/ai-search.interface';

export type DdPageState = 'search' | 'loading' | 'results';

export interface RecentDdSearch {
  savedAt: number;
  data: AiGeneratedQueryData;
  // The request sent to generate/company, so reopening a recent restores the
  // parameter grid and allows editing / re-generation.
  request?: CompanyQueryRequest;
  // The lexicon that produced the query — needed for verified volumes and the
  // add-term suggestions when a recent is reopened.
  lexicon?: Lexicon;
}

// A top event row with its bar width precomputed once (avoids a per-change-
// detection method binding in the template).
export interface DdTopEvent {
  name: string;
  count: number;
  barWidth: string;
}

export interface DdResultTiles {
  sentiment: number | null;
  eventsTotal: number | null;
  topEvents: DdTopEvent[];
  volumeTotal: number | null;
}

export const EMPTY_DD_TILES = (): DdResultTiles => ({
  sentiment: null,
  eventsTotal: null,
  topEvents: [],
  volumeTotal: null,
});

// The company fields the reviewer may edit on the results page. Everything else
// in the request (identifiers, exchanges, indexes, surface forms, collisions) is
// server-curated and forwarded untouched.
export type DdEditableField =
  | 'country'
  | 'city'
  | 'sector'
  | 'website'
  | 'message';

// Request fields edited as a list of terms — one pill each, same interaction as
// the query terms below them.
export type DdListField = 'key_persons' | 'exclusion_seeds';

// Stat-card changes after a re-run (null before the first re-run).
export interface DdTileDeltas {
  sentiment: number | null;
  events: number | null;
  volume: number | null;
}

// 12-month lookback is the due-diligence framing (matches the DD reports).
export const DD_TIMEFRAME = '365';
export const DD_TIMEFRAME_LABEL = 'last 12 months';
export const DD_TOP_EVENTS_SHOWN = 6;
